module.exports = __webpack_public_path__ + "img/logo-hakuodo.0181deb2.png";